<template>
    <div>
        <el-page-header @back="goBack" content="每日优惠配置"></el-page-header>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="类型：">
                    <el-select  v-model="queryData.dailyType">
                        <el-option
                                v-for="item in dailyTypeList"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11" >
                    <el-button type="primary" @click="queryList">查询</el-button>
                    <el-button class="sub-sub" type="primary" @click="showDetails('创建')">创建商品</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table border :data="dataList">
                <el-table-column label="ID" prop="id"  align="center"></el-table-column>
                <el-table-column label="类型"   align="center">
                    <template slot-scope="scope">
                        {{scope.row.dailyItemType | iosFilter(cgDailyShopItemTypeObj)}}
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column label="图片" align="center" width="100px">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px"/>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center" prop="currentPrice"></el-table-column>
                <el-table-column label="发放数量" align="center" prop="gainNumber"></el-table-column>
                <el-table-column label="操作" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="removeItem(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px"
                       :close-on-click-modal="false">
                <el-form :model="itemForm" label-width="150px">
                    <el-form-item label="类型：" >
                        <el-select  v-model="itemForm.dailyItemType">
                            <el-option
                                    v-for="item in dailyTypeList"
                                    :label="item.name"
                                    :value="item.id"
                                    :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物品ID :" >
                        <el-select  v-model="itemForm.goodId" placeholder="请选择" @change="findGood">
                            <el-option
                                    v-for="item in goods"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品名称 :">
                        <el-input style="width: 300px" type="text" v-model="itemForm.name"  ></el-input>
                    </el-form-item>
                    <el-form-item label="价格 :" >
                        <el-input-number v-model="itemForm.currentPrice"  :min="0" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="数量 :" >
                        <el-input-number v-model="itemForm.gainNumber"  :min="0" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="图片 :" >
                        <el-upload :headers="headers"
                                   class="avatar-uploader"
                                   :action="uploadURL"
                                   :show-file-list="false"
                                   :on-success="handleCISuccess"
                                   :before-upload="beforeAvatarUpload">
                            <img v-if="itemForm.image" :src="VUE_APP_CDN_URL+itemForm.image" class="avatar">
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirm">确 定</el-button>
                        <el-button type="info" @click="cancel">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </h1>
    </div>

</template>

<script>
    import {
        dailyShopItemType,
        searchDailyShopItem,
        deleteDailyShopItem,
        saveDailyShopItem,
        findGoodById,
        goodsSelections,
    } from "@/http/cgApi";
    import settingMix from '@/utils/mix/common-setting'
    export default {
        name: "CgShopDailyManage",
        mixins: [settingMix],
        data(){
            return{
                dailyTypeList:[],
                needCgDailyShoppingItemType:true,
                cgDailyShopItemTypeObj:{},
                VUE_APP_IOS_URL: '',
                VUE_APP_CDN_URL: '',
                dialogVisible: false,
                dialogTitle: '',
                headers: {},
                labelWidth: '200px',
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                queryData: {
                    dailyType : 0,
                    prop: "id",
                    order: "desc"
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                itemForm:{
                    "id": null,
                    "goodId": null,
                    "cid": null,
                    "image": '',
                    "name": '',
                    "dailyItemType": 0,
                    "currentPrice": 1,
                    "gainNumber": 1
                },
                dataList:[],
                goods:[],
            }
        },
        methods:{
            goBack() {
                this.$router.push({ path: '/cgShopManage'});
            },
            getSelections(){
                dailyShopItemType().then(resp => {
                    this.dailyTypeList = resp.data.info;
                })
            },
            queryList() {
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                searchDailyShopItem(this.queryData).then(resp => {
                    if (resp.data.status === 0) {
                        this.dataList = resp.data.info.content;
                        this.page.totalElements = resp.data.info.totalElements;
                    }
                })
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryList();
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryList();
            },
            handleCISuccess(response) {
                this.itemForm.image = response.info;
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            showDetails(title, row) {
                this.goodsSelections();
                console.log(this.queryData)
                this.itemForm={
                        "id": null,
                        "goodId": null,
                        "cid": null,
                        "image": '',
                        "name": '',
                        "dailyItemType": this.queryData.dailyType,
                        "currentPrice": this.queryData.dailyType==2 ?1:0,
                        "gainNumber": 1
                },
                this.dialogTitle = title;
                this.dialogVisible = true;
                if (row) {
                    this.itemForm={
                        "id": row.id,
                        "goodId": row.goodId,
                        "cid": row.cid,
                        "image": row.image,
                        "name": row.name,
                        "dailyItemType": row.dailyItemType,
                        "currentPrice": row.currentPrice,
                        "gainNumber": row.gainNumber
                    }
                }
            },
            findGood(){
                findGoodById(this.itemForm.goodId).then(resp => {
                    if (resp.data.status === 0) {
                        this.itemForm.name = resp.data.info.name;
                        this.itemForm.cid = resp.data.info.cid;
                        this.itemForm.image =  resp.data.info.imageUrl;
                    }
                })
            },
            cancel() {
                this.dialogVisible = false;
            },
            goodsSelections(){
                goodsSelections().then(resp =>{
                    this.goods = resp.data.info;
                })
            },
            confirm() {
                let _message = '';
                if (this.itemForm.name === '') {
                    _message = '请选择物品'
                }
                if (_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                // console.log(this.itemForm)
                saveDailyShopItem(this.itemForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.queryList();
                        this.dialogVisible = false;
                    }
                })
            },
            removeItem(id) {
                this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteDailyShopItem(id).then(resp => {
                        if (resp.data.status === 0) {
                            this.queryList();
                        }
                    });
                }).catch(() => {
                })
            },
        },
        created() {
            this.headers = {Authorization: this.$store.state.user.token}
            this.getSelections();
            this.queryList();
        },
        mounted() {
            this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>
